import { EntryPage } from '@components/entry-page/entry-page';
import ModalsContainer from '@components/modals/modals-container';
import { useBreadcrumb } from '@hooks/useBreadcrumb';
import { useGetResources } from '@hooks/useGetResources';
import { useAppSelector } from '@src/store';
import { getErrorLabel, hasPageHeader } from '@utils/verktoyContainer-utils';
import { useLocation } from 'react-router';

import PageLoader from '@helsenorge/core-framework/page-loader';
import PageRoot from '@helsenorge/core-framework/pageroot';
import { getPath } from '@helsenorge/framework-utils/hn-page';

export const EntryPageContainer = (): React.JSX.Element | null => {
  const error = useAppSelector(globalState => globalState.verktoy.error);
  const resources = useGetResources();
  const location = useLocation();
  const breadcrumbLink = useBreadcrumb();

  const fullPath = `/${getPath()}${location.pathname}`;

  if (!resources) {
    return null;
  }
  return (
    <PageRoot
      hasPageHeader={hasPageHeader(location.pathname)}
      pageTitle={resources.entryPage_header}
      pageDescription={resources.entryPage_ingress}
      breadcrumbLink={breadcrumbLink}
      redirectTo={fullPath}
      enablePageviewTracking
      enableSurveys
    >
      <div className="verktoy__wrapper">
        <PageLoader inline resources={resources} error={error ? getErrorLabel(resources, error) : undefined}>
          <ModalsContainer />
          <EntryPage />
        </PageLoader>
      </div>
    </PageRoot>
  );
};
